<script>

/**
 * Form-element component
 */
export default {
  props:
  {
    aluno: Object
  }
};
</script>

<template>
  <div class="mb-3 row">
    <label class="col-md-2 col-form-label">Aluno</label>
    <div class="col-md-10">
      <input class="form-control" :value="aluno.nome" readonly />
    </div>
  </div>
</template>